export default {
    methods: {
        convertSource(source, isDark = true) {
            const values = {
                'admin-panel': isDark ? '/images/webWhite.svg' : '/images/web.svg',
                'mobile-app-android': isDark ? '/images/androidWhite.svg' : '/images/android.svg',
                'mobile-app-ios': isDark ? '/images/appleWhite.svg' : '/images/apple.svg',
                'web-app': isDark ? '/images/globeWhite.svg' : '/images/globe.svg',
                'landing-page': isDark ? '/images/LP2.png' : '/images/LP.png',
                'my-hammer': '/images/myhammer.png',
            }

            const unknown = isDark ? '/images/unknownWhite.svg' : '/images/unknown.svg'
            return values[source] || unknown
        },
    },
}
